import { parseJSON } from 'utils/common'

export const ModelExchangeVariantItem = (obj = {}) => {
	return {
		//color: parseJSON(obj?.attributes)?.color?.value || '',
		//size: parseJSON(obj?.attributes)?.size?.value || '',
		attributes: parseJSON(obj?.attributes) || {},
		price: obj?.cost || 0,
		imageUrl: parseJSON(obj?.imageUrl) || [],
		currency: obj?.currency,
		name: obj?.name || '',
		precision: obj?.precision || 0,
		categories: obj?.product?.categories || [],
		description: obj?.product?.description || '',
		productExternalId: obj?.product?.productExternalId || '',
		productId: obj?.product?.productId || '',
		productVariantExternalId: obj?.productVariantExternalId || '',
		productVariantId: obj?.productVariantId || '',
		quantity: obj?.quantity || 0,
		stockStatus: obj?.stockStatus || '',
		vatRate: obj?.vatRate || 0,
	}
}
